var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "view-action-map" },
    [
      _c(
        "cms-heading",
        { attrs: { title: "Actie kaart", level: "2" } },
        [
          _vm.isAdminOrAdvisor
            ? [
                !_vm.exporting && !_vm.updatingStatus
                  ? _c(
                      "cms-button",
                      {
                        attrs: { icon: "magicon-jump-right-up" },
                        on: {
                          click: function ($event) {
                            _vm.exporting = true
                          },
                        },
                      },
                      [_vm._v("Exporteer acties")]
                    )
                  : _vm._e(),
                _vm.exporting
                  ? _c(
                      "div",
                      { staticClass: "export-map" },
                      [
                        _c("span", [
                          _vm._v(
                            "Selecteer een gebied op de kaart om te exporteren"
                          ),
                        ]),
                        _c(
                          "cms-button",
                          {
                            attrs: { disabled: !_vm.selectedMarkerIds },
                            on: {
                              click: function ($event) {
                                return _vm.exportActions()
                              },
                            },
                          },
                          [_vm._v("Exporteren")]
                        ),
                        _c(
                          "cms-button",
                          {
                            attrs: { color: "default-light" },
                            on: { click: _vm.resetExport },
                          },
                          [_vm._v("Annuleren")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.updatingStatus && !_vm.exporting
                  ? _c(
                      "cms-button",
                      {
                        attrs: { icon: "magicon-edit" },
                        on: {
                          click: function ($event) {
                            _vm.updatingStatus = true
                          },
                        },
                      },
                      [_vm._v("Status wijzigen (max. 25 acties)...")]
                    )
                  : _vm._e(),
                _vm.updatingStatus
                  ? _c(
                      "div",
                      { staticClass: "update-status-map" },
                      [
                        _c("span", [
                          _vm._v(
                            "Selecteer een gebied op de kaart om de status te wijzigen"
                          ),
                        ]),
                        _c("cms-dropdown", {
                          attrs: {
                            disabled: !_vm.selectedMarkerIds,
                            placeholder: "Status wijzigen...",
                            options: _vm.stateOptions,
                          },
                          on: { input: _vm.updateStatus },
                        }),
                        _c(
                          "cms-button",
                          {
                            attrs: { color: "default-light" },
                            on: { click: _vm.resetUpdateStatus },
                          },
                          [_vm._v("Annuleren")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c("open-layers-map", {
        directives: [
          {
            name: "spinner",
            rawName: "v-spinner",
            value: _vm.loading,
            expression: "loading",
          },
        ],
        attrs: {
          markers: _vm.markers,
          selectable: _vm.exporting || _vm.updatingStatus,
          clustered: "",
        },
        on: { "marker-click": _vm.onMarkerClick, selection: _vm.onSelection },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }